import React, { useState, useEffect } from 'react';
import { useDebouncedEffect } from 'shared/lib/debounce';

const NumberInput = ({ value, max, min = 0, onChange, onBlur }) => {
  const [inputValue, setInputValue] = useState(value);
  const [clicked, setClicked] = useState(false);

  useDebouncedEffect(
    () => {
      let newValue = normalizedValue(inputValue);
      if (max !== undefined && newValue > max) newValue = max;
      if (newValue < min) newValue = min;
      if (newValue.toString() !== value) {
        onChange(newValue.toString());
      }
    },
    clicked ? 0 : 1000,
    [inputValue]
  );

  useEffect(() => {
    if (value !== inputValue) {
      setInputValue(value);
    }
  }, [value]);

  useEffect(() => {
    const timer = setTimeout(
      () => {
        setClicked(false);
      },
      clicked ? 1000 : 0
    );
    return () => clearTimeout(timer);
  }, [clicked]);

  const normalizedValue = (val) => {
    const newValue = parseInt(val);
    return isNaN(newValue) ? min : newValue;
  };

  const handleChange = (event) => {
    setInputValue(event.target.value);
  };

  const up = () => {
    let newValue = normalizedValue(inputValue) + 1;
    if (max !== undefined && newValue >= max) newValue = max;
    setClicked(true);
    setInputValue(newValue);
  };
  const down = () => {
    let newValue = normalizedValue(inputValue) - 1;
    if (newValue <= min) newValue = min;
    setClicked(true);
    setInputValue(newValue);
  };

  return (
    <div className="input-group number-input">
      <input
        className="form-control fantastic-form-control number-input__value"
        type="text"
        value={inputValue}
        onChange={handleChange}
        onBlur={onBlur}
      />
      <div className="input-group-btn-vertical number-input__buttons">
        <button type="button" className="btn btn-form" onClick={up}>
          <div className="fa fa-caret-up"></div>
        </button>
        <button type="button" className="btn btn-form" onClick={down}>
          <div className="fa fa-caret-down"></div>
        </button>
      </div>
    </div>
  );
};

export default NumberInput;
